import React from "react";
import { Link, useAsyncError, useNavigate } from "react-router-dom";
import { LockClosedIcon } from "@heroicons/react/20/solid";
import { HiArrowNarrowRight } from "react-icons/hi";
import Card from "../components/Card";
import { useEffect, useState } from "react";
import { database } from "../firebase.config";
import { getDatabase, ref, set, push, remove } from "firebase/database";

function Home() {
  const [email,setemail] = useState("")
  const [show_modal, setshow_modal] = useState(false)

  const handleChange = (e) => setemail(e.target.value);

  const save_email = async () => {
    console.log(email)
    const emailRef = ref(database, "email");
    const statusRef = push(emailRef);
  
    set(statusRef, {
      email: email
    });
    setshow_modal(true)
  }
  
  return (
    <>
      <center>
        <div name="home" className="w-full  bg-[#0a192f]">
          <div className="max-w-[1000px] px-8 flex flex-col h-full">
            <p className="text-pink-600 mt-10 ml-600">
              Welcome to Easyforms.ai!<br></br>
            </p>
            <div className="flex ml-500 mt-10 mr-50 mb-50">
              <h1 className="text-4xl sm:text-7xl font-bold text-[#ccd6f6]">
                Unlock the Power of AI for Effortless Feedback Form Creation📝
                <br></br>
              </h1>
            </div>

            <br></br>
            <ul>
              <h2 className="text-2xl sm:text-5xl  text-[#8892b0]">
                Are you tired of spending countless hours designing and setting
                up feedback forms, surveys, and idea validation forms?
              </h2>
              <h2 className="text-2xl sm:text-5xl  text-[#8892b0]">
                We have the solution you've been waiting for!
              </h2>
            </ul>
            <br></br>
            <h2 className="text-2xl sm:text-3xl text-pink-600">
              Join our Beta Program by signing below ⬇️
            </h2>
            <p className="text-[#8892b0] py-4 max-w-[700px]"></p>
            <div className="group row">
              <input
                type="text"
                placeholder="Your Email Address"
                className="input input-bordered input-primary w-full max-w-xs"
                value={email}
                onChange={handleChange}
              />
              <button className="text-white group border-2 px-6 py-3 my-2 flex items-center hover:bg-pink-600 hover:border-pink-600"
              onClick={save_email}>
                Join
              </button>
            </div>
            { show_modal && <p className="text-2xl sm:text-3xl text-pink-600">Thank you for signing up. We'll get back to you as soon as we launch!</p>}
            <br></br>
            <br></br>
            <br></br>
            <h1 className="text-4xl sm:text-4xl font-bold text-[#ccd6f6]">
              How it works?<br></br>
            </h1>
            <br></br>
            <ul className="steps steps-vertical">
              <li data-content="●" className="step step-primary">
                <div className="flex flex-row">
                  <h2 className="text-2xl sm:text-2xl text-pink-600 mr-2">
                    AI-Powered Question Suggestions:
                  </h2>
                  <h1 className="text-l sm:text-l font-bold text-[#ccd6f6]">
                    Tell us your goals, and our AI will suggest questions
                    tailored to your needs.
                    <br></br>
                  </h1>
                </div>
              </li>
              <li data-content="●" className="step step-primary">
                <div className="flex flex-row">
                  <h2 className="text-2xl sm:text-2xl text-pink-600 mr-2">
                    Customize and Design:
                  </h2>
                  <h1 className="text-l sm:text-l font-bold text-[#ccd6f6]">
                    Easily customize the form's appearance and layout according
                    to your brand's style.
                    <br></br>
                  </h1>
                </div>
              </li>
              <li data-content="●" className="step step-primary">
                <div className="flex flex-row">
                  <h2 className="text-2xl sm:text-2xl text-pink-600 mr-2">
                    One-Click Google Forms Conversion:
                  </h2>
                  <h1 className="text-l sm:text-l font-bold text-[#ccd6f6]">
                    Convert your forms to Google Forms with a single click for
                    easy data collection and analysis.
                    <br></br>
                  </h1>
                </div>
              </li>
            </ul>
            <br></br>
            <br></br>
            <br></br>
            <h1 className="text-4xl sm:text-4xl font-bold text-[#ccd6f6]">
              Why Choose EasyForms.ai ?<br></br>
            </h1>
            <br></br>
            <ul className="steps steps-vertical">
              <li data-content="✓" className="step step-primary">
                <div className="flex flex-row">
                  <h2 className="text-2xl sm:text-2xl text-pink-600 mr-2">
                    Time Saving:
                  </h2>
                  <h1 className="text-l sm:text-l font-bold text-[#ccd6f6]">
                    No more hours wasted on designing forms and thinking of
                    questions.
                    <br></br>
                  </h1>
                </div>
              </li>
              <li data-content="✓" className="step step-primary">
                <div className="flex flex-row">
                  <h2 className="text-2xl sm:text-2xl text-pink-600 mr-2">
                    Effortless Idea Validation:
                  </h2>
                  <h1 className="text-l sm:text-l font-bold text-[#ccd6f6]">
                    Get valuable insights to refine your concepts and make
                    informed decisions.
                    <br></br>
                  </h1>
                </div>
              </li>
              <li data-content="✓" className="step step-primary">
                <div className="flex flex-row">
                  <h2 className="text-2xl sm:text-2xl text-pink-600 mr-2">
                    User-Friendly:
                  </h2>
                  <h1 className="text-l sm:text-l font-bold text-[#ccd6f6]">
                    Our platform is designed for everyone, from beginners to
                    experts.
                    
                  </h1>
                </div>
              </li>
            </ul>
            <br></br>
          </div>
 
        </div>
        
        <footer className="footer footer-center p-4">
  <aside>
    <p>EasyForms.ai</p>
  </aside>
</footer>

      </center>
    </>
  );
}

export default Home;
